interface BookmarkToggleProps {
  active: boolean
  onChange: (active: boolean) => void
  label?: string
  className?: string
}

export default function BookmarkToggle({
  active,
  onChange,
  label = 'Bookmarked only',
  className = '',
}: BookmarkToggleProps) {
  return (
    <button
      type="button"
      onClick={() => onChange(!active)}
      className={`inline-flex items-center gap-1.5 px-3 py-1.5 text-sm rounded-md border transition-colors ${
        active
          ? 'bg-amber-50 border-amber-300 text-amber-700'
          : 'bg-white border-gray-300 text-gray-600 hover:bg-gray-50'
      } ${className}`}
    >
      <svg
        className={`h-4 w-4 ${active ? 'fill-amber-500' : 'fill-none stroke-current'}`}
        viewBox="0 0 24 24"
        strokeWidth={active ? 0 : 2}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M5 5a2 2 0 012-2h10a2 2 0 012 2v16l-7-3.5L5 21V5z"
        />
      </svg>
      {label}
    </button>
  )
}
